export default {
    movimientosCuentasPorPagar: [],
    movimientosCuentasPorPagarFiltros: [],
    movimientosCuentasPorPagarCount: 0,
    movimientosCuentasPorCobrar: [],
    movimientosCuentasPorCobrarFiltros: [],
    movimientosCuentasPorCobrarCount: 0,
    compra: [],
    compraFiltros: [],
    compraCount: 0,
    lastNumberFCompra: 0, 
    lastNumberControlCompra: 0, 
    venta: [],
    ventaFiltros: [],
    ventaCount: 0,
    lastNumberFVenta: 0, 
    lastNumberControlVenta: 0,
}